export default {
    observability: {
        expectedErrors: []
    }
};

//# sourceMappingURL=defaultConfig.js.map